
import { useStore } from "vuex";
import { ComputedRef, onBeforeMount } from "vue";
import { computed } from "@vue/reactivity";
import { dispatchErrorBox, formattedDate } from "../../mixins";
import { Receipt } from "../../../../../domain/entities/shop/order/receipt";
import { RepositoryException } from "../../../../../domain/exceptions/exceptions";
import ContentFallback from "../moldure/ContentFallback.vue";
import { wrapLoading } from "../../../utils/wrap_loading";

export default {
  components: { ContentFallback },
  setup() {
    const store = useStore();

    /** List of orders. */
    const orders: ComputedRef<Array<Receipt>> = computed(() => {
      return store.getters["shop_module/ordersHistory"];
    });

    /** Getter to set the button with the receipt url. */
    const receipt: ComputedRef<Receipt> = computed(() => {
      return store.getters["shop_module/receipt"];
    });

    onBeforeMount(async () => {
      await wrapLoading(async () => {
        try {
          await store.dispatch("shop_module/ordersHistory");
        } catch (e) {
          if (e instanceof RepositoryException) {
            await dispatchErrorBox(e.message);
          } else {
            console.error(e);
            await dispatchErrorBox("Ocorreu um erro inesperado.");
          }
        }
      });
    });

    /** Function to generate the receipt. */
    async function generateNewReceipt(orderID: number): Promise<void> {
      try {
        await store.dispatch("shop_module/createReceipt", orderID);
        window.open(receipt.value.receiptUrl, "_blank");
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    return {
      orders,
      receipt,
      generateNewReceipt,
      formattedDate
    };
  }
};
